export default "__VITE_ASSET__yXwY_y43guN7skkDx7d1zQ__";